import { and, eq, getTableColumns, isNull, sql } from "drizzle-orm";

import type { WsBroadcastAction } from "@storyboard/web-client";
import { bulkInsert } from "@/db/bulkInsert";
import { db } from "@/db/db";
import { broadcastAction, workflowItem } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emptyQuery } from "@/models/emptyQuery.ts";
import { emitTableUpdates } from "@/models/eventing/TableEventManager";
import { logQuery } from "@/models/logQuery.ts";

export async function bulkUpsertBroadcastAction(records: WsBroadcastAction[]) {
  const deduped = deduplicateByKeyValue(records, (item) => item.id);
  await bulkInsert(broadcastAction, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [broadcastAction.id],
      set: {
        workspaceId: sql`excluded."workspaceId"`,
        workflowItemId: sql`excluded."workflowItemId"`,
        broadcastId: sql`excluded."broadcastId"`,
        createdAt: sql`excluded."createdAt"`,
        updatedAt: sql`excluded."updatedAt"`,
      },
    },
  });
  emitTableUpdates(["broadcast_action"]);
}

export function broadcastActionSelect({ workspaceId }: { workspaceId?: string }) {
  const query = db
    .selectDistinct({
      ...getTableColumns(broadcastAction),
    })
    .from(broadcastAction)
    .innerJoin(workflowItem, eq(broadcastAction.workflowItemId, workflowItem.id))
    .where(and(eq(workflowItem.workspaceId, workspaceId), isNull(workflowItem.deletedAt)));

  if (!workspaceId) {
    return emptyQuery as unknown as typeof query;
  }
  logQuery("Broadcasts", query);
  return query;
}
